/*
ajax请求函数模块
返回值: promise对象(异步返回的数据是: response.data)
 */
import axios from 'axios'
export default function ajax (url, data = {}, type = 'GET', _that = this, config) {
  return new Promise((resolve, reject) => {
    // 执行异步ajax请求
    if (_that) {
      _that.bus.$emit('loading', true);
    }
    let promise
    if (type === 'GET') {
      // 准备url query参数数据
      let dataStr = '' //数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&'
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      // window.console.log(Object.keys(data), 'ajax get 请求响应');
      // 发送get请求
      promise = axios.get(url, {

      })
    } else if (type === 'POST') {
      // 发送post请求
      if (config) {
        promise = axios.post(url, data, config)
      } else {
        promise = axios.post(url, data)
      }
    } else if (type === 'DELETE') {
      promise = axios.delete(url, data)
    } else if (type === 'PUT') {
      promise = axios.put(url, data)
    }
    promise.then((response) => {
      // 成功了调用resolve()
      if (_that) {
        _that.bus.$emit('loading', false);
      }
      resolve(response.data)
    }).catch((error) => {
      //失败了调用reject()
      if (_that) {
        _that.bus.$emit('loading', false);
      }
      reject(error)
      // 请求报错信息
      error.returnInfo && _that.$message.error(error.returnInfo);
    })
  })
}

/*
const response = await ajax()
const result = response.data

const resule = await ajax()
 */
